// extracted by mini-css-extract-plugin
export default {"crippleBox":"HeaderView_crippleBox__8t-4E","expand":"HeaderView_expand__UHGMF","overflowVisible":"HeaderView_overflowVisible__jazeT","collapse":"HeaderView_collapse__7I+uG"};